import React from 'react';
import PropTypes from 'prop-types';
import { createUseStyles, Text, Button } from '@Sage/hoi-poi-ui';
import styles from "./styles/drawerHeader";
const name = 'DrawerHeader';
const useStyles = createUseStyles(styles, name);
function DrawerHeader(_ref) {
  let {
    isSaving,
    onSaveCreate,
    isSaveDisabled,
    locales = {
      title: 'Title',
      cancel: 'Cancel',
      save: 'Save',
      saveAndCreate: 'Save & Create'
    },
    onCancel = () => {},
    onSave = () => {}
  } = _ref;
  const classes = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.header
  }, /*#__PURE__*/React.createElement(Text, {
    type: "subtitle1",
    className: classes.title
  }, locales.title), /*#__PURE__*/React.createElement("div", {
    className: classes.headerActions
  }, locales.cancel && /*#__PURE__*/React.createElement(Button, {
    size: "big",
    type: "terciary",
    className: `${classes.leftButton} drawer-header__cancel__button`,
    onClick: onCancel
  }, locales.cancel), onSaveCreate && /*#__PURE__*/React.createElement(Button, {
    size: "big",
    type: "terciary",
    onClick: onSaveCreate,
    className: `${classes.leftButton} drawer-header__add-create__button`
  }, locales.saveAndCreate), /*#__PURE__*/React.createElement(Button, {
    size: "big",
    className: `${classes.saveButton} drawer-header__save__button`,
    onClick: onSave,
    isLoading: isSaving,
    isDisabled: isSaveDisabled
  }, locales.save)));
}
process.env.NODE_ENV !== "production" ? DrawerHeader.propTypes = {
  locales: PropTypes.shape({
    title: PropTypes.string,
    cancel: PropTypes.string,
    save: PropTypes.string,
    saveAndCreate: PropTypes.string
  }),
  onCancel: PropTypes.func,
  onSave: PropTypes.func
} : void 0;
const component = /*#__PURE__*/React.memo(DrawerHeader);
component.displayName = name;
export default component;